import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Infographic as View } from 'ui-components'
import { useCaptureMapInfographic } from '~map-preview/hooks/useCaptureMapInfographic'
import {
  setLayout,
  setLegendInfographic,
  setSize,
  setTitle,
  useInfographicLegend,
  useInfographicTitle,
  useLayout
} from '~map-preview/states/infographic'
import { useMapNavStore } from '~map-preview/states/mapNav'
import { useIsMapLegendOpen } from '~map-preview/states/ui'
import { useMap } from '~map-preview/states/map'
import { mapSharedEvent } from 'tag-manager/map_shared'

function Infographic() {
  const map = useMap()
  const { setOpenInfoGraphic } = useMapNavStore()
  const dispatch = useDispatch()
  const layout = useLayout()
  const infographicTitle = useInfographicTitle()
  const thumbnail = useCaptureMapInfographic()
  const legend = useInfographicLegend()
  const isMapLegendOpen = useIsMapLegendOpen()

  useEffect(() => {
    return () => {
      setOpenInfoGraphic(false)
    }
  }, [setOpenInfoGraphic])

  const handleDownload = () => {
    mapSharedEvent('info_graphic')
    const link = document.createElement('a')
    link.download = `${map?.name || 'map'}.png`
    link.href = thumbnail || ''
    link.click()
  }

  const handleLayoutChange = (value: string) => {
    dispatch(setLayout(value))
  }

  const handleSizeChange = (value: string) => {
    dispatch(setSize(value))
  }

  const handleLegendChange = (value: boolean) => {
    dispatch(setLegendInfographic(value))
  }

  const handleTitleChange = (value: boolean) => {
    dispatch(setTitle(value))
  }

  return (
    <View
      showLegend={isMapLegendOpen}
      layout={layout}
      title={infographicTitle}
      legend={legend}
      onLayoutChange={handleLayoutChange}
      onSizeChange={handleSizeChange}
      onDownload={handleDownload}
      onLegendChange={handleLegendChange}
      onTitleChange={handleTitleChange}
    />
  )
}

export { Infographic }
